import { DataLayer } from "../../constants/action-constants/DataLayerActionConstants";

export const getCustomDataLayers = (
  excludeArchive,
  keyWord = "",
  pageNumber = 1,
  pageSize = 10
) => ({
  type: DataLayer.GET_CUSTOM_DATA_LAYERS,
  payload: {
    excludeArchive,
    pageNumber,
    pageSize,
    keyWord,
  },
});

export const toggleCustomDataLayerStatus = (id, isArchived) => ({
  type: DataLayer.CHANGE_DATA_LAYER_STATUS,
  payload: {
    id,
    isArchived,
  },
});

export const getDataLayerDetails = (id) => ({
  type: DataLayer.GET_DATA_LAYER_DETAILS,
  payload: {
    id,
  },
});

export const downloadDataLayerTemplate = (layerType, fileName) => ({
  type: DataLayer.DOWNLOAD_DATA_LAYER_TEMPLATE,
  payload: { layerType, fileName },
});

export const uploadDataLayerTemplate = (
  layerType,
  layerName,
  files,
  history
) => ({
  type: DataLayer.UPLOAD_DATA_LAYER_TEMPLATE,
  payload: { layerType, layerName, files, history },
});
